import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFilePpt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 165,
	height: 216,
	viewBox: "0 0 165 216",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M139.71 49.24C134.241 49.2373 128.997 47.0644 125.129 43.1982C121.261 39.3321 119.085 34.0889 119.08 28.62V0H26.9099C23.3752 -2.4406e-07 19.8751 0.696337 16.6096 2.04932C13.3441 3.4023 10.3771 5.38537 7.87818 7.88525C5.37922 10.3851 3.3973 13.3529 2.04553 16.6189C0.693768 19.8849 -0.00131167 23.3853 1.85821e-06 26.92V189.13C0.0106002 196.26 2.85042 203.094 7.89588 208.132C12.9413 213.17 19.7799 216 26.9099 216H137.51C141.045 216 144.545 215.304 147.81 213.951C151.076 212.598 154.043 210.615 156.542 208.115C159.041 205.615 161.023 202.647 162.375 199.381C163.726 196.115 164.421 192.615 164.42 189.08V49.2L139.71 49.24Z",
				fill: "#CC5334"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.42 49.24H139.71C134.241 49.2373 128.997 47.0644 125.129 43.1982C121.261 39.3321 119.085 34.0889 119.08 28.62V0L164.42 49.24Z",
			fill: "#CC5334"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.417 85.0833H81V138.917H117.417V85.0833Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.417 140.5H85.7501C84.8749 140.5 84.1667 139.792 84.1667 138.917C84.1667 138.042 84.8749 137.333 85.7501 137.333H115.833V86.6667H85.7501C84.8749 86.6667 84.1667 85.9585 84.1667 85.0833C84.1667 84.2082 84.8749 83.5 85.7501 83.5H117.417C118.292 83.5 119 84.2082 119 85.0833V138.917C119 139.792 118.292 140.5 117.417 140.5Z",
			fill: "#CC5334"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.3333 74L43 82.2609V141.739L87.3333 150V74Z",
			fill: "#CC5334"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M43 82.2609V83.0526L87.3333 74.7917V74L43 82.2609Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M43 141.739L87.3333 150V149.209L43 140.948V141.739Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.2501 93C89.129 93 84.1667 97.9622 84.1667 104.083C84.1667 110.204 89.129 115.167 95.2501 115.167C101.371 115.167 106.333 110.204 106.333 104.083H95.2501V93Z",
			fill: "#CC5334"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.4167 89.8333V100.917H109.5C109.5 94.7955 104.538 89.8333 98.4167 89.8333Z",
			fill: "#CC5334"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.083 119.917H85.75V123.083H111.083V119.917Z",
			fill: "#CC5334"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.083 129.417H85.75V132.583H111.083V129.417Z",
			fill: "#CC5334"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.417 140.5C118.292 140.5 119 139.792 119 138.917V115.167L87.3333 83.5V140.5H117.417Z",
			fill: "url(#paint0_linear_156_189)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.7917 115.958H63.5834C68.386 115.958 72.2917 112.053 72.2917 107.25C72.2917 102.448 68.386 98.5417 63.5834 98.5417H58.0417V125.628L62.7917 125.967V115.958ZM62.7917 103.292H63.5834C65.7667 103.292 67.5417 105.067 67.5417 107.25C67.5417 109.433 65.7667 111.208 63.5834 111.208H62.7917V103.292Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .05,
			d: "M87.3333 74L43 82.2609V141.739L87.3333 150V74Z",
			fill: "url(#paint1_linear_156_189)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.417 83.5H87.3333V74L43 82.2609V141.739L87.3333 150V140.5H117.417C118.292 140.5 119 139.792 119 138.917V85.0833C119 84.2082 118.292 83.5 117.417 83.5Z",
			fill: "url(#paint2_linear_156_189)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_156_189",
				x1: 73.0833,
				y1: 97.75,
				x2: 116.953,
				y2: 141.62,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .1 }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_156_189",
				x1: 42.9974,
				y1: 111.998,
				x2: 87.3335,
				y2: 111.998,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", { offset: 1 })]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_156_189",
				x1: 38.0491,
				y1: 92.8782,
				x2: 122.31,
				y2: 132.17,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .2
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgIconFilePpt;
